import { useEffect, useId } from 'react';
import type { ReactNode } from 'react';

import {
  DEFAULT_CANVAS_LAYOUT_MOBILE_DETENTS,
  useCanvasLayoutContext,
} from './canvasLayoutContext';

export interface CanvasLayoutSidePanelProps {
  isOpen: boolean;
  title: string;
  closePanel: () => void;
  children: ReactNode;
  loading?: boolean;
  statusText?: string;
  additionalButtons?: ReactNode;
  className?: string;
  mobileDetents?: Array<string | number>;
}

export default function CanvasLayoutSidePanel({
  isOpen,
  title,
  closePanel,
  children,
  loading,
  statusText,
  additionalButtons,
  className,
  mobileDetents = DEFAULT_CANVAS_LAYOUT_MOBILE_DETENTS,
}: CanvasLayoutSidePanelProps) {
  const id = useId();
  const { registerSidePanel, clearSidePanel } = useCanvasLayoutContext();

  useEffect(() => {
    if (!isOpen) {
      clearSidePanel(id);
      return;
    }

    registerSidePanel({
      id,
      title,
      closePanel,
      children,
      loading,
      statusText,
      additionalButtons,
      className,
      mobileDetents,
    });

    return () => {
      clearSidePanel(id);
    };
  }, [
    additionalButtons,
    children,
    className,
    clearSidePanel,
    closePanel,
    id,
    isOpen,
    loading,
    mobileDetents,
    registerSidePanel,
    statusText,
    title,
  ]);

  return null;
}
